import {qspost} from '@/plugins/axios'


/*
 * 独立民调统计 第一部分 上面的数据统计
 * @constructor jack
 * */
export const duLiMinDiao = (xiangMuId, xiaoQuId) => qspost('/Index/Xinxuqiu/duLiMinDiao', {
  xiangMuId,
  xiaoQuId
})


/*
 * 独立民调列表
 * @constructor jack
 * */
export const duLiMinDiaoList = (xiaoQuId,page,pageSize) => qspost('/Index/Dulimindiao/duLiMinDiaoList', {
  xiaoQuId,page,pageSize
})

/*
 * 创建|修改 独立民调
 * @constructor jack
 * */
export const duLiMinDiaoAdd = (xiaoQuId,minDiaoZhuTi,startTime,endTime,beizhu,id) => qspost('/Index/Dulimindiao/duLiMinDiaoAdd', {
  xiaoQuId,minDiaoZhuTi,startTime,endTime,beizhu,id
})


/*
 * 删除独立民调
 * @constructor jack
 * */
export const duLiMinDiaoDel = (duLiMinDiaoId) => qspost('/Index/Dulimindiao/duLiMinDiaoDel', {
  duLiMinDiaoId
})

/*
 * 民调范围选择 楼、门、户 列表
 * @constructor jack
 * */
export const minDiaoFanWeiLouMenHuList = (xiaoQuId) => qspost('/Index/Dulimindiao/minDiaoFanWeiLouMenHuList', {
  xiaoQuId
})

/*
 * 民调范围 详情
 * @constructor jack
 * */
export const duLiMinDiaoFanWeiShow = (duLiMinDiaoId) => qspost('/Index/Dulimindiao/duLiMinDiaoFanWeiShow', {
  duLiMinDiaoId
})

/*
 * 民调范围 添加
 * @constructor jack
 * */
export const duLiMinDiaoFanWeiAdd = (duLiMinDiaoId,xiangMuId,xiaoQuId,louMenHuJson) => qspost('/Index/Dulimindiao/duLiMinDiaoFanWeiAdd', {
  duLiMinDiaoId,xiangMuId,xiaoQuId,louMenHuJson
})

/*
* 独立民调 - 民调范围 - 民调结果列表
*  * @constructor jack
* */
export const duLiMinDiaoJieGuoList = (duLiMinDiaoId,status) => qspost('/Index/Dulimindiao/duLiMinDiaoJieGuoList', {
  duLiMinDiaoId,status
})

/*
* 民调结果 - 更新民调的结果
*  * @constructor jack
* */
export const minDiaoJieGuoUpdate = (minDiaoFanWeiId,status) => qspost('/Index/Dulimindiao/minDiaoJieGuoUpdate', {
  minDiaoFanWeiId,status
})


